import React from "react";
import PropTypes from "prop-types";
import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Layout from "../../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignContent: "center",
      alignItems: "center",
      display: "grid",
      gap: `${theme.spacing(4)}px`,
      gridArea: "content",
      justifyItems: "center",
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4)
    },
  })
);

export const Thanks = ({ location }): ReactElement => {
  const classes = useStyles();

  return (
    <Layout pathname={location.pathname}>
      <Container className={classes.root} component="main" fixed>
        <Typography component="h1" variant="h4">
          Thank you
        </Typography>
        <div>
          <p>
            You will now be added to out mailing list for new properties that match your criteria.
          </p>
          <p>
            If you have any immediate questions, please don't hesitate to call us on 020 7940 9940.
          </p>
        </div>
      </Container>
    </Layout>
  );
};

Thanks.propTypes = {
  location: PropTypes.object
};

export default Thanks;